import type React from 'react'
import type { FC } from 'react'
import type { IEpisode, ISeason } from '../Playlist.h'
import type { IPlaylistPopoverContent } from './PlaylistPopoverContent.h'

import { useCallback } from 'react'
import { CardDirection } from 'blocks/Cards'
import { TVShowCardWithDescription } from 'blocks/Cards/TVShowCardWithDescription/TVShowCardWithDescription'
import {
  formatProgress,
  getPlaylistContent,
  getPlaylistDurationInfo,
} from '../lib'

const isSeason = (item: ISeason | IEpisode): item is ISeason => {
  return 'episodes' in item
}

export const PlaylistPopoverContent: FC<IPlaylistPopoverContent> = ({
  posterAspectRatio,
  posterWidth,
  handleEpisodeClick,
  handleSeasonClick,
  isSeasons,
  isTabSeasons,
  activeSeason,
  activeEpisode,
  playlist,
}) => {
  const { loading, error } = playlist || {}

  const content = getPlaylistContent({
    isTabSeasons,
    playlist,
    activeSeason,
    isSeasons,
  })

  const isContentSeason = isTabSeasons && isSeasons

  const onClick = useCallback(
    (
      e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
      item: IEpisode | ISeason
    ) => {
      return isContentSeason && isSeason(item)
        ? handleSeasonClick(e, item)
        : handleEpisodeClick(e, item)
    },
    [isContentSeason, handleSeasonClick, handleEpisodeClick]
  )

  const activeContent = isContentSeason ? activeSeason : activeEpisode

  if (!!error || Boolean(loading)) return null

  return (
    <>
      {content?.map((item: ISeason | IEpisode) => {
        const durationInfo = getPlaylistDurationInfo(item)

        return (
          <TVShowCardWithDescription
            description={item.name ?? ''}
            key={item.id}
            direction={CardDirection.Horizontal}
            posterUrl={item.landscapeImageUrl ?? ''}
            title={item.title}
            posterAspectRatio={posterAspectRatio}
            isSelected={activeContent?.id === item?.id}
            posterWidth={posterWidth}
            onClick={(e) => onClick(e, item)}
            labelTitle={durationInfo.length && `${durationInfo.length}`}
            labelPrice={item?.labelPrice}
            paid={item?.paid}
            rented={item?.rented}
            progress={formatProgress({
              duration: durationInfo.duration,
              stoppedTime: durationInfo.stoppedTime,
              watched: durationInfo.watched,
            })}
            aclBlockedBy={item.blockedByAcl}
          />
        )
      })}
    </>
  )
}
